import React from "react";
import { Route } from "react-router-dom";
import { CustomNavigationClient } from "../utils/NavigationClient";
import { useNavigate } from "react-router-dom";

import NavBar from "../screean/login/ui-components/NavBar";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
// Material-UI imports
const Oauth = React.lazy(() => import("../screean/login/oauth"));

export function oauth() {
  return (
    <Route
      path="/oauth"
      element={
        <LazySuspense>
          {/*<Oauth pca={pca} />*/}
          <NavBar />
        </LazySuspense>
      }
    />
  );
}
